const dorsaLockProductModal = (modal) => {
  if (!modal || modal.hasAttribute('open')) return;

  modal.setAttribute('aria-hidden', 'true');
  modal.setAttribute('inert', '');

  modal.style.setProperty(
    'pointer-events',
    'none',
    'important'
  );

  modal.style.setProperty(
    'visibility',
    'hidden',
    'important'
  );

  modal.style.setProperty(
    'opacity',
    '0',
    'important'
  );

  modal.style.setProperty(
    'z-index',
    '-1',
    'important'
  );

  modal.style.setProperty(
    'cursor',
    'default',
    'important'
  );
};

const dorsaLockClosedProductModals = () => {
  document
    .querySelectorAll('product-modal')
    .forEach(dorsaLockProductModal);
};

dorsaLockClosedProductModals();

document.addEventListener(
  'DOMContentLoaded',
  dorsaLockClosedProductModals,
  { once: true }
);

document.addEventListener(
  'shopify:section:load',
  dorsaLockClosedProductModals
);

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',

    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.slides = Array.from(
          this.querySelectorAll(
            '[data-dorsa-lightbox-slide]'
          )
        );

        this.thumbs = Array.from(
          this.querySelectorAll(
            '[data-dorsa-lightbox-thumb]'
          )
        );

        this.prevButton =
          this.querySelector(
            '[data-dorsa-lightbox-prev]'
          );

        this.nextButton =
          this.querySelector(
            '[data-dorsa-lightbox-next]'
          );

        this.viewport =
          this.querySelector(
            '[data-dorsa-lightbox-viewport]'
          );

        this.currentElement =
          this.querySelector(
            '[data-dorsa-lightbox-current]'
          );

        this.totalElement =
          this.querySelector(
            '[data-dorsa-lightbox-total]'
          );

        this.gesture =
          this.querySelector(
            '[data-dorsa-lightbox-gesture]'
          );

        this.activeIndex = 0;

        this.pointerStartX = null;
        this.pointerStartY = null;
        this.pointerLastX = null;

        this.dragging = false;
        this.dorsaIsOpen = false;

        this.hardLockClosed();

        this.prevButton?.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopPropagation();

            this.step(-1);
          }
        );

        this.nextButton?.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopPropagation();

            this.step(1);
          }
        );

        this.thumbs.forEach(
          (thumb) => {
            thumb.addEventListener(
              'click',
              (event) => {
                event.preventDefault();
                event.stopPropagation();

                this.dismissGesture();

                this.activateByMediaId(
                  thumb.dataset.mediaId,
                  true
                );
              }
            );

            thumb.addEventListener(
              'pointerup',
              (event) => {
                event.stopPropagation();
              }
            );
          }
        );

        this.querySelectorAll(
          '[data-dorsa-lightbox-control], [data-dorsa-lightbox-chrome]'
        ).forEach(
          (element) => {
            element.addEventListener(
              'pointerup',
              (event) => {
                event.stopPropagation();
              }
            );
          }
        );

        this.addEventListener(
          'keydown',
          (event) => {
            if (!this.dorsaIsOpen) return;

            if (
              event.key ===
              'ArrowLeft'
            ) {
              event.preventDefault();

              this.step(-1);
            }

            if (
              event.key ===
              'ArrowRight'
            ) {
              event.preventDefault();

              this.step(1);
            }
          }
        );

        this.viewport?.addEventListener(
          'pointerdown',
          this.onPointerDown.bind(this),
          {
            passive: true,
          }
        );

        this.viewport?.addEventListener(
          'pointermove',
          this.onPointerMove.bind(this),
          {
            passive: true,
          }
        );

        this.viewport?.addEventListener(
          'pointerup',
          this.onPointerUp.bind(this)
        );

        this.viewport?.addEventListener(
          'pointercancel',
          this.resetPointer.bind(this)
        );
      }

      hardLockClosed() {
        this.dorsaIsOpen = false;

        this.removeAttribute(
          'open'
        );

        this.setAttribute(
          'aria-hidden',
          'true'
        );

        this.setAttribute(
          'inert',
          ''
        );

        this.style.setProperty(
          'pointer-events',
          'none',
          'important'
        );

        this.style.setProperty(
          'visibility',
          'hidden',
          'important'
        );

        this.style.setProperty(
          'opacity',
          '0',
          'important'
        );

        this.style.setProperty(
          'z-index',
          '-1',
          'important'
        );

        this.style.setProperty(
          'cursor',
          'default',
          'important'
        );
      }

      unlockForOpen() {
        this.dorsaIsOpen = true;

        this.removeAttribute(
          'inert'
        );

        this.setAttribute(
          'aria-hidden',
          'false'
        );

        this.style.removeProperty(
          'pointer-events'
        );

        this.style.removeProperty(
          'visibility'
        );

        this.style.removeProperty(
          'opacity'
        );

        this.style.removeProperty(
          'z-index'
        );

        this.style.removeProperty(
          'cursor'
        );
      }

      show(opener) {
        this.unlockForOpen();

        this.openedBy = opener;

        this.gesture?.classList.remove(
          'is-dismissed'
        );

        this.showActiveMedia(
          opener?.getAttribute(
            'data-media-id'
          )
        );

        super.show(opener);

        this.preloadAroundActive();

        window.requestAnimationFrame(
          () => {
            this.scrollActiveThumb(
              false
            );

            this.viewport?.focus({
              preventScroll: true,
            });
          }
        );
      }

      hide() {
        this.resetPointer();

        if (
          this.hasAttribute(
            'open'
          )
        ) {
          super.hide();
        } else {
          document.body.classList.remove(
            'overflow-hidden'
          );
        }

        this.hardLockClosed();
      }

      showActiveMedia(
        mediaId
      ) {
        const normalizedId =
          mediaId ||
          this.openedBy?.getAttribute(
            'data-media-id'
          );

        this.activateByMediaId(
          normalizedId,
          false
        );
      }

      activateByMediaId(
        mediaId,
        animateThumb = true
      ) {
        if (
          !this.slides.length
        ) {
          return;
        }

        const requestedId =
          String(
            mediaId ??
            ''
          );

        let nextIndex =
          this.slides.findIndex(
            (slide) =>
              String(
                slide.dataset.mediaId ??
                ''
              ) ===
              requestedId
          );

        if (
          nextIndex < 0 &&
          requestedId.includes('-')
        ) {
          const rawId =
            requestedId
              .split('-')
              .pop();

          nextIndex =
            this.slides.findIndex(
              (slide) =>
                String(
                  slide.dataset.mediaId ??
                  ''
                ) ===
                rawId
            );
        }

        if (
          nextIndex < 0
        ) {
          nextIndex = 0;
        }

        this.activate(
          nextIndex,
          animateThumb
        );
      }

      activate(
        nextIndex,
        animateThumb = true
      ) {
        if (
          !this.slides.length
        ) {
          return;
        }

        const total =
          this.slides.length;

        this.activeIndex =
          (
            nextIndex +
            total
          ) %
          total;

        window.pauseAllMedia();

        this.slides.forEach(
          (
            slide,
            index
          ) => {
            const isActive =
              index ===
              this.activeIndex;

            slide.classList.toggle(
              'active',
              isActive
            );

            slide.setAttribute(
              'aria-hidden',
              isActive
                ? 'false'
                : 'true'
            );

            slide.style.transform =
              '';
          }
        );

        const activeSlide =
          this.slides[
            this.activeIndex
          ];

        const activeMediaId =
          activeSlide?.dataset
            .mediaId;

        this.thumbs.forEach(
          (thumb) => {
            const isActive =
              thumb.dataset
                .mediaId ===
              activeMediaId;

            thumb.classList.toggle(
              'is-active',
              isActive
            );

            if (
              isActive
            ) {
              thumb.setAttribute(
                'aria-current',
                'true'
              );
            } else {
              thumb.removeAttribute(
                'aria-current'
              );
            }
          }
        );

        if (
          this.currentElement
        ) {
          this.currentElement
            .textContent =
            String(
              this.activeIndex +
              1
            );
        }

        if (
          this.totalElement
        ) {
          this.totalElement
            .textContent =
            String(
              total
            );
        }

        const activeImage =
          activeSlide?.querySelector(
            'img'
          );

        if (
          activeImage
        ) {
          activeImage.loading =
            'eager';

          activeImage.fetchPriority =
            'high';
        }

        this.preloadAroundActive();

        this.scrollActiveThumb(
          animateThumb
        );
      }

      step(
        direction
      ) {
        if (
          this.slides.length <
          2
        ) {
          return;
        }

        this.dismissGesture();

        this.activate(
          this.activeIndex +
            direction,
          true
        );
      }

      scrollActiveThumb(
        smooth = true
      ) {
        const activeThumb =
          this.thumbs.find(
            (thumb) =>
              thumb.classList.contains(
                'is-active'
              )
          );

        if (
          !activeThumb
        ) {
          return;
        }

        activeThumb.scrollIntoView({
          behavior:
            smooth &&
            !window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            ).matches
              ? 'smooth'
              : 'auto',

          block:
            'nearest',

          inline:
            'center',
        });
      }

      preloadAroundActive() {
        if (
          !this.slides.length
        ) {
          return;
        }

        const indexes = [
          this.activeIndex,

          (
            this.activeIndex +
            1
          ) %
            this.slides.length,

          (
            this.activeIndex -
            1 +
            this.slides.length
          ) %
            this.slides.length,
        ];

        indexes.forEach(
          (
            index,
            order
          ) => {
            const image =
              this.slides[
                index
              ]?.querySelector(
                'img'
              );

            if (
              !image
            ) {
              return;
            }

            image.loading =
              order === 0
                ? 'eager'
                : 'lazy';

            if (
              order === 0
            ) {
              image.fetchPriority =
                'high';
            }
          }
        );
      }

      dismissGesture() {
        this.gesture?.classList.add(
          'is-dismissed'
        );
      }

      onPointerDown(
        event
      ) {
        if (
          !this.dorsaIsOpen
        ) {
          return;
        }

        if (
          event.pointerType ===
            'mouse' &&
          event.button !== 0
        ) {
          return;
        }

        if (
          event.target.closest(
            '[data-dorsa-lightbox-control], [data-dorsa-lightbox-thumb]'
          )
        ) {
          return;
        }

        this.pointerStartX =
          event.clientX;

        this.pointerStartY =
          event.clientY;

        this.pointerLastX =
          event.clientX;

        this.dragging =
          false;

        if (
          this.viewport
            ?.setPointerCapture
        ) {
          try {
            this.viewport
              .setPointerCapture(
                event.pointerId
              );
          } catch (
            error
          ) {
            void error;
          }
        }
      }

      onPointerMove(
        event
      ) {
        if (
          !this.dorsaIsOpen
        ) {
          return;
        }

        if (
          this.pointerStartX ===
            null ||
          this.pointerStartY ===
            null
        ) {
          return;
        }

        const deltaX =
          event.clientX -
          this.pointerStartX;

        const deltaY =
          event.clientY -
          this.pointerStartY;

        if (
          !this.dragging
        ) {
          if (
            Math.abs(
              deltaX
            ) < 8 &&
            Math.abs(
              deltaY
            ) < 8
          ) {
            return;
          }

          if (
            Math.abs(
              deltaY
            ) >
            Math.abs(
              deltaX
            )
          ) {
            this.resetPointer();

            return;
          }

          this.dragging =
            true;
        }

        this.pointerLastX =
          event.clientX;

        const activeSlide =
          this.slides[
            this.activeIndex
          ];

        if (
          !activeSlide
        ) {
          return;
        }

        const resisted =
          Math.max(
            -56,
            Math.min(
              56,
              deltaX *
                0.22
            )
          );

        activeSlide
          .style
          .transform =
          `translate3d(${resisted}px,0,0) scale(.996)`;
      }

      onPointerUp(
        event
      ) {
        if (
          !this.dorsaIsOpen
        ) {
          return;
        }

        const isInsideSlide =
          Boolean(
            event.target.closest(
              '[data-dorsa-lightbox-slide]'
            )
          );

        if (
          this.pointerStartX ===
          null
        ) {
          if (
            isInsideSlide
          ) {
            event.stopPropagation();
          }

          return;
        }

        const endX =
          Number.isFinite(
            event.clientX
          )
            ? event.clientX
            : this.pointerLastX;

        const deltaX =
          endX -
          this.pointerStartX;

        const activeSlide =
          this.slides[
            this.activeIndex
          ];

        if (
          activeSlide
        ) {
          activeSlide
            .style
            .transform =
            '';
        }

        if (
          this.dragging &&
          Math.abs(
            deltaX
          ) >= 42
        ) {
          this.step(
            deltaX < 0
              ? 1
              : -1
          );
        }

        if (
          this.dragging
        ) {
          this.dismissGesture();
        }

        if (
          isInsideSlide ||
          this.dragging
        ) {
          event.stopPropagation();
        }

        if (
          this.viewport
            ?.releasePointerCapture
        ) {
          try {
            this.viewport
              .releasePointerCapture(
                event.pointerId
              );
          } catch (
            error
          ) {
            void error;
          }
        }

        this.resetPointer();
      }

      resetPointer() {
        const activeSlide =
          this.slides?.[
            this.activeIndex
          ];

        if (
          activeSlide
        ) {
          activeSlide
            .style
            .transform =
            '';
        }

        this.pointerStartX =
          null;

        this.pointerStartY =
          null;

        this.pointerLastX =
          null;

        this.dragging =
          false;
      }
    }
  );
}